import { BaseTranslator } from '../base';

import vi from './languages/vi.json';
import en from './languages/en.json';
import zh from './languages/zh.json';
import id from './languages/id.json';

export type TAdminLanguageTokens = keyof typeof vi;

export class Admin extends BaseTranslator {
  private static _instance: Admin;

  public static instance() {
    if (!Admin._instance) {
      Admin._instance = new Admin();
    }

    return Admin._instance;
  }

  protected override builder(): void {
    this.setResources([
      {
        language: 'vi',
        resource: vi,
      },
      {
        language: 'en',
        resource: en,
      },
      {
        language: 'zh',
        resource: zh,
      },
      {
        language: 'id',
        resource: id,
      },
    ]);
  }
}
